import PermissionButton from '../../permissions/PermissionButton';
import React, { useState } from 'react';
import { Form, Input, Button, Card, Space, Divider, Typography, message } from 'antd';
import { useCreateCom } from '../../hooks/comHooks'; // Adjust the import path as necessary
import { UserOutlined, PhoneOutlined, MailOutlined, IdcardOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

const ComForm = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const { handleCreate } = useCreateCom();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await handleCreate(values);
      message.success('Commercial créé avec succès');
      form.resetFields();
      onSuccess?.();
    } catch (error) {
      message.error(error?.response?.data?.message || error?.message || 'Erreur lors de la création du commercial');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card title="Ajouter un commercial">
      <Paragraph type="secondary" style={{ marginBottom: 16 }}>
        Complétez les coordonnées du commercial : ces informations seront visibles dans les filtres et documents de vente.
      </Paragraph>
      <Divider orientation="left">Informations</Divider>
      <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
        <Form.Item
          label="Nom & prénom"
          name="nom"
          rules={[{ required: true, message: 'Veuillez saisir le nom' }]}
        >
          <Input placeholder="Nom du commercial" prefix={<IdcardOutlined />} autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Téléphone"
          name="tel"
          rules={[{ required: true, message: 'Veuillez saisir un numéro de téléphone' }]}
        >
          <Input placeholder="Numéro de téléphone" prefix={<PhoneOutlined />} autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Email professionnel"
          name="email"
          rules={[
            { type: 'email', message: 'Adresse email invalide' },
            { required: true, message: 'Veuillez saisir une adresse email' }
          ]}
        >
          <Input placeholder="Adresse email professionnelle" prefix={<MailOutlined />} autoComplete="off" />
        </Form.Item>
        <Divider />
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={() => form.resetFields()} disabled={submitting}>
            Effacer
          </Button>
          <PermissionButton permissionModule="commercials" permissionAction="create" type="primary" htmlType="submit" loading={submitting} icon={<UserOutlined />}>
            Enregistrer
          </PermissionButton>
        </Space>
      </Form>
    </Card>
  );
};

export default ComForm;
